import { PAYMENT_GATEWAYS } from 'common/constants/SharedConstants';
import GlobalPaymentAddCardTemplate from '../sharedTemplates/GlobalPaymentAddCardTemplate';
import { isCurrentPageRedirectFromRNA, redirectToAccountPage } from 'common/utilities/utils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

export const addNewCardDefaultValues = {
  isAddNewCard: true,
  paymentProvider: '',
  paymentCardDetails: {
        cardNumber: '',
        cardExpDate: '',
        cardCVV: '',
        cardHolderName: '',
        deliveryAddressCheck: true,
        saveCardCheck: false,
        nickName: '',
        isFormValid: false,
  },
  tenantId: '',
  tender: {
    name: 'credit-card',
    payload: {},
  },
  globalPaymentsAccesstoken: '',
  globalPaymentsOneTimeResponse: '',
  globalPaymentValidateAdressResponse: '',
  globalPaymentSaveCard: '',
  saveCardCheck: false,
  savedCards:[],
  customerId:'',
  firstName:'',
  lastName: '',
  countryCodeNumeric: '',
  billingAddressAndSaveCard: {
    Showcheckbox: false,
    fulladdress: '',
    city: '',
    pincode: '',
    state: '',
    issavecard: false,
    nickName: '',
    isvalid: false,
    defaultAddressSelected: false,
    defaultSaveCard: false,
    isBillingAddressFormDetailsValid: false,
    country: '',
  },
  allowedTenders: [],
}

export const getAddnewCardBaseTemplate = (props) => {
  if (props?.paymentDetails?.paymentProvider === PAYMENT_GATEWAYS.GLOBAL_PAYMENTS) {
    return <GlobalPaymentAddCardTemplate {...props} />;
  }
  else {
    return <></>;
  }
}

export const redirectBackToPayment = history => {
  if (isCurrentPageRedirectFromRNA(window.location)) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ cancel: 'cancel' }));
  } else {
    history?.push({
      pathname: '/account',
      selectOption: TRANSLATE_MAPPING_KEY?.MY_PAYMENT_METHODS,
    });
  }
};

